const FETCH_SEEKER_INFO = 'leads/seekerInfo/FETCH_SEEKER_INFO';
const FETCH_SEEKER_INFO_SUCCEEDED = 'leads/seekerInfo/FETCH_SEEKER_INFO_SUCCEEDED';
const FETCH_SEEKER_INFO_FAILED = 'leads/seekerInfo/FETCH_SEEKER_INFO_FAILED';

export { FETCH_SEEKER_INFO, FETCH_SEEKER_INFO_SUCCEEDED, FETCH_SEEKER_INFO_FAILED };
